var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rt-container" }, [
    _c(
      "div",
      { staticClass: "rt-table" },
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.table.rows, border: "" },
          },
          [
            _c("el-table-column", {
              attrs: { fixed: "", prop: "label", label: "", width: "150" },
            }),
            _vm._l(_vm.table.columns, function (col, index) {
              return _c("el-table-column", {
                key: index,
                attrs: { "min-width": "150", label: col.label },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: { border: false },
                            model: {
                              value: _vm.dataValue[scope.row.id][col.id],
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.dataValue[scope.row.id],
                                  col.id,
                                  $$v
                                )
                              },
                              expression: "dataValue[scope.row.id][col.id]",
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            }),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }